import { useRouter } from 'next/router';
import React from 'react';
import { APP_IMG } from 'src/constants';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';

function SectionOne({ data }: any) {
  const router = useRouter();
  console.log(data);
  return (
    <SectionWrapper className='section-one' background={convertDatasets(data, 'background-image', true)} background_mb={convertDatasets(data, 'background-image-mobile', true)}>
      <div className='container content'>
        <div className='info-wrapper'>
          <a
            className='register-button w-40'
            href={convertDatasets(data, 'link-vejpongosot', true)}
            // ! DATALAYER
            onClick={() => {
              sendDataLayerGlobal({
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router.pathname,
                section: 'section-1',
                position: 'on:vejpongosot120years-page',
                data: {
                  heading: convertDatasets(data, 'button-text', true)
                }
              });
            }}
          >
            <img className='svg-logo' src={convertDatasets(data, 'logo-landing', true)} />
          </a>
          <img className='title-image' src={convertDatasets(data, 'heading-text', true)} />
        </div>
        <div className='info-wrapper-button  mb-15'>
          <a
            className='register-button w-20'
            href={convertDatasets(data, 'link-thepeople', true)}
            // ! DATALAYER
            onClick={() => {
              sendDataLayerGlobal({
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router.pathname,
                section: 'section-1',
                position: 'on:vejpongosot120years-page',
                data: {
                  heading: convertDatasets(data, 'button-text', true)
                }
              });
            }}
          >
            <img className='H1-image img-thepeople' src={convertDatasets(data, 'logo-thepeople', true)} />
          </a>
          <a
            className='register-button w-20'
            href={convertDatasets(data, 'link-vejpongosot', true)}
            // ! DATALAYER
            onClick={() => {
              sendDataLayerGlobal({
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router.pathname,
                section: 'section-1',
                position: 'on:vejpongosot120years-page',
                data: {
                  heading: convertDatasets(data, 'button-text', true)
                }
              });
            }}
          >
            <img className='H1-image' src={convertDatasets(data, 'button', true)} />
          </a>
        </div>
      </div>
    </SectionWrapper>
  );
}
interface StyledProps {
  background: string;
  background_mb: string;
}
const SectionWrapper = styled.div<StyledProps>`
  position: relative;
  width: 100%;
  margin: auto;
  height: auto;
  min-height: 1200px;
  background-image: url(${props => props?.background});
  background-size: auto;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 60px;

  @media (max-width: 1181px) {
    background-size: contain;
    padding: 40px 0;
    background-position: bottom;
    min-height: unset;
  }

  @media (max-width: 475px) {
    background-size: contain;
    padding: 10px 0;
    min-height: unset;
    background-image: url(${props => props?.background_mb});
    background-position: bottom;

    .mb-15 {
      margin: 15px 0px 10px;
    }
  }

  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;
    @media (max-width: 1181px) {
      padding: 0 15px;
      gap: 10px;
    }

    @media (max-width: 475px) {
      padding: 0;
      gap: 0px;
    }

    .svg-logo {
      width: 100%;

      @media (max-width: 1181px) {
        width: 100%;
      }

      @media (max-width: 475px) {
        width: 100%;
      }
    }

    .info-wrapper-button {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;

      @media (max-width: 1181px) {
        gap: 50px;
      }

      @media (max-width: 475px) {
        justify-content: center;
        gap: 0px;
      }

      .title-image {
        width: 100%;

        @media (max-width: 1181px) {
          width: 85%;
          gap: 250px;
        }

        @media (max-width: 475px) {
          width: 110%;
          margin-bottom: 0.25rem;
        }
      }
    }
    .info-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      gap: 500px;

      @media (max-width: 1181px) {
        gap: 250px;
      }

      @media (max-width: 475px) {
        gap: 50px;
      }

      .title-image {
        width: 100%;

        @media (max-width: 1181px) {
          width: 85%;
          gap: 250px;
        }

        @media (max-width: 475px) {
          width: 110%;
          margin-bottom: 0.25rem;
        }
      }

      .des-text {
        text-align: center;
        font-size: 30px;
        font-weight: 500;
        color: #f8f9f8;
        line-height: 1;
        letter-spacing: 0.01em;
        text-shadow: 0.098em 0.098em 0 rgba(93, 0, 15, 0.4);

        @media (max-width: 1181px) {
          font-size: 20px;
        }

        @media (max-width: 475px) {
          width: 100%;
          font-size: 12px;
          line-height: 1.1;
          font-weight: 500;
        }
      }
    }

    .address {
      text-align: center;
      font-size: 24px;
      font-weight: 400;
      color: #f8f9f8;
      line-height: 1.38;
      letter-spacing: 0.01em;
      text-shadow: 0.044em 0.044em 0 rgba(0, 0, 0, 0.4);

      @media (max-width: 1181px) {
        font-size: 22px;
      }

      @media (max-width: 475px) {
        font-size: 16px;
      }
    }

    .H1-image {
      width: 100%;
      cursor: pointer;

      @media (max-width: 1181px) {
        width: 100%;
      }

      @media (max-width: 475px) {
        width: 70%;
      }
    }

    .img-thepeople {
      background: white;
      padding: 1rem 1.75rem;
      border-radius: 60px;
      @media (max-width: 475px) {
        padding: 0.5rem 1.25rem;
      }
    }

    .w-40 {
      width: 35%;

      @media (max-width: 475px) {
        margin: 2rem 0px 6rem;
        width: 70% !important;
      }
    }

    .w-20 {
      width: 25%;
    }

    .register-button {
      display: flex;
      justify-content: center;
      z-index: 2;
      transition: all 0.3s ease-in-out;

      &:hover {
        // Uncomment and customize for hover styles
        // background-color: #f8f9f8;
        // color: #b30e0e;
      }

      @media (max-width: 1181px) {
        // Uncomment for font size adjustments
        // font-size: 28px;
      }

      @media (max-width: 475px) {
        width: 40%;
        // Uncomment for font size adjustments
        // font-size: 22px;
      }
    }
  }
`;

export default SectionOne;
